import { ADD_CUSTOM_RULE_MANAGEMENT, ADD_CUSTOM_RULE_MANAGEMENT_FAIL, ADD_CUSTOM_RULE_MANAGEMENT_SUCCESS, ADD_WORKFLOW_RULE_MANAGEMENT, ADD_WORKFLOW_RULE_MANAGEMENT_FAIL, ADD_WORKFLOW_RULE_MANAGEMENT_SUCCESS, DELETE_CUSTOM_RULE, DELETE_CUSTOM_RULE_FAIL, DELETE_CUSTOM_RULE_SUCCESS, DELETE_CUSTOM_WORKFLOW, DELETE_CUSTOM_WORKFLOW_FAIL, DELETE_CUSTOM_WORKFLOW_SUCCESS, EXECUTE_CUSTOM_RULE, EXECUTE_CUSTOM_RULE_FAIL, EXECUTE_CUSTOM_RULE_SUCCESS, GET_ADDITIONAL_INFO, GET_ADDITIONAL_INFO_FAIL, GET_ADDITIONAL_INFO_SUCCESS, GET_CUSTOM_RULE, GET_CUSTOM_RULE_FAIL, GET_CUSTOM_RULE_SUCCESS, GET_CUSTOM_WORKFLOW, GET_CUSTOM_WORKFLOW_DETAIL, GET_CUSTOM_WORKFLOW_DETAIL_FAIL, GET_CUSTOM_WORKFLOW_DETAIL_SUCCESS, GET_CUSTOM_WORKFLOW_FAIL, GET_CUSTOM_WORKFLOW_SUCCESS, GET_FULL_TEST_FOR_NORMAL_RULE, GET_FULL_TEST_FOR_RULE, GET_FULL_TEST_FOR_RULE_FAIL, GET_FULL_TEST_FOR_RULE_SUCCESS, GET_NORMAL_RANGE_SUB, GET_NORMAL_RANGE_SUB_FAIL, GET_NORMAL_RANGE_SUB_SUCCESS, GET_NORMAL_RULE_BY_TESTCODE, GET_NORMAL_RULE_BY_TESTCODE_FAIL, GET_NORMAL_RULE_BY_TESTCODE_SUCCESS, GET_POSITION_SCROLL, GET_RESULT_TIME, GET_RESULT_TIME_FAIL, GET_RESULT_TIME_SUCCESS, GET_RULE_INSTRUMENT_ALERT, GET_RULE_INSTRUMENT_ALERT_FAIL, GET_RULE_INSTRUMENT_ALERT_SUCCESS, GET_RULE_INSTRUMENT_RANGE, GET_RULE_INSTRUMENT_RANGE_FAIL, GET_RULE_INSTRUMENT_RANGE_SUCCESS, GET_RULE_NORMAL_RANGE, GET_RULE_NORMAL_RANGE_FAIL, GET_RULE_NORMAL_RANGE_SUCCESS, GET_RULE_PATIENT_RANGE, GET_RULE_PATIENT_RANGE_FAIL, GET_RULE_PATIENT_RANGE_SUCCESS, GET_RULE_RESULT_TIME, GET_RULE_RESULT_TIME_FAIL, GET_RULE_RESULT_TIME_SUCCESS, GET_RULE_RULER_BASE, GET_RULE_RULER_BASE_FAIL, GET_RULE_RULER_BASE_SUCCESS, IMPORT_RULE_MANAGEMENT, IMPORT_RULE_MANAGEMENT_FAIL, IMPORT_RULE_MANAGEMENT_SUCCESS, RESET_TESTS_SEARCH_QUERY, SET_FULL_TEST_FOR_RULE, SET_TESTS_SEARCH_QUERY, UPDATE_ADDITIONAL_INFO, UPDATE_ADDITIONAL_INFO_FAIL, UPDATE_ADDITIONAL_INFO_SUCCESS, UPDATE_CUSTOM_RULE, UPDATE_CUSTOM_RULE_FAIL, UPDATE_CUSTOM_RULE_SUCCESS, UPDATE_CUSTOM_WORKFLOW, UPDATE_CUSTOM_WORKFLOW_FAIL, UPDATE_CUSTOM_WORKFLOW_SUCCESS, UPDATE_NORMAL_RANGE_BY_TESTCODE, UPDATE_NORMAL_RANGE_BY_TESTCODE_FAIL, UPDATE_NORMAL_RANGE_BY_TESTCODE_SUCCESS, UPDATE_NORMAL_RANGE_SUB, UPDATE_NORMAL_RANGE_SUB_FAIL, UPDATE_NORMAL_RANGE_SUB_SUCCESS, UPDATE_RESULT_TIME, UPDATE_RESULT_TIME_FAIL, UPDATE_RESULT_TIME_SUCCESS, UPDATE_RULE_MANAGEMENT, UPDATE_RULE_MANAGEMENT_FAIL, UPDATE_RULE_MANAGEMENT_SUCCESS } from "./actionTypes"

const INIT_STATE = {
  RuleManagements: [],
  ruleTest: {},
  tests: [],
  paging: {},
  loadingTests: false,
  updatedTime: new Date(),
  error: {},
  searchQuery: {},
  rules: [],
  workflows: [],
  workflow: {},
  loadingExecuteCustomRule: false,
  runRuleTest: {},
  testsForRule: [],
  normalRangeSub: []
}

const RuleManagement = (state = INIT_STATE || null, action) => {
  switch (action.type) {
    case GET_FULL_TEST_FOR_NORMAL_RULE:
      return {
        ...state,
        normalRuleTest: action.payload
      }
    case GET_FULL_TEST_FOR_RULE:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_FULL_TEST_FOR_RULE_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        paging: { dataSize: action.payload.length },
        loadingTests: false,
        updatedTime: new Date(),
      }

    case SET_FULL_TEST_FOR_RULE:
      {
        return {
          ...state,
          testsForRule: action.payload,
          loadingTests: false,
        }
      }

    case GET_FULL_TEST_FOR_RULE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }
    case RESET_TESTS_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: {},
      }
    case SET_TESTS_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: { ...action.payload },
      }

    case GET_RULE_NORMAL_RANGE:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_RULE_NORMAL_RANGE_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
      }

    case GET_RULE_NORMAL_RANGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }

    case GET_RULE_PATIENT_RANGE:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_RULE_PATIENT_RANGE_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
      }

    case GET_RULE_PATIENT_RANGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }

    case GET_RULE_INSTRUMENT_RANGE:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_RULE_INSTRUMENT_RANGE_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
        paging: { dataSize: action.payload.length },
      }

    case GET_RULE_INSTRUMENT_RANGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }

    case UPDATE_RULE_MANAGEMENT:
      return {
        ...state,
      }
    case UPDATE_RULE_MANAGEMENT_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_RULE_MANAGEMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RULE_INSTRUMENT_ALERT:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_RULE_INSTRUMENT_ALERT_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
      }

    case GET_RULE_INSTRUMENT_ALERT_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }

    case GET_RULE_RULER_BASE:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_RULE_RULER_BASE_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
      }

    case GET_RULE_RULER_BASE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }
    case ADD_CUSTOM_RULE_MANAGEMENT:
      return {
        ...state,
      }
    case ADD_CUSTOM_RULE_MANAGEMENT_SUCCESS:
      return {
        ...state,
      }

    case ADD_CUSTOM_RULE_MANAGEMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_WORKFLOW_RULE_MANAGEMENT:
      return {
        ...state,
      }
    case ADD_WORKFLOW_RULE_MANAGEMENT_SUCCESS:
      return {
        ...state,
      }

    case ADD_WORKFLOW_RULE_MANAGEMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CUSTOM_RULE:
      return {
        ...state,
        loadingTests: true,
      }
    case GET_CUSTOM_RULE_SUCCESS:
      return {
        ...state,
        rules: action.payload,
        loadingTests: false,
      }

    case GET_CUSTOM_RULE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CUSTOM_WORKFLOW:
      return {
        ...state,
        loadingTests: true,
      }
    case GET_CUSTOM_WORKFLOW_SUCCESS:
      return {
        ...state,
        workflows: action.payload,
        loadingTests: false,
      }

    case GET_CUSTOM_WORKFLOW_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CUSTOM_RULE:
      return {
        ...state,
        loadingTests: true,
      }
    case DELETE_CUSTOM_RULE_SUCCESS:
      return {
        ...state,
        rule: action.payload,
        loadingTests: false,
      }

    case DELETE_CUSTOM_RULE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CUSTOM_WORKFLOW:
      return {
        ...state,
        loadingTests: true,
      }
    case DELETE_CUSTOM_WORKFLOW_SUCCESS:
      return {
        ...state,
        workflow: action.payload,
        loadingTests: false,
      }

    case DELETE_CUSTOM_WORKFLOW_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CUSTOM_WORKFLOW:
      return {
        ...state,
        loadingTests: true,
      }
    case UPDATE_CUSTOM_WORKFLOW_SUCCESS:
      return {
        ...state,
        workflow: action.payload,
        loadingTests: false,
      }

    case UPDATE_CUSTOM_WORKFLOW_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CUSTOM_WORKFLOW_DETAIL:
      return {
        ...state,
        loadingTests: true,
      }
    case GET_CUSTOM_WORKFLOW_DETAIL_SUCCESS:
      return {
        ...state,
        workflow: action.payload,
        loadingTests: false,
      }

    case GET_CUSTOM_WORKFLOW_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CUSTOM_RULE:
      return {
        ...state,
        loadingTests: true,
      }
    case UPDATE_CUSTOM_RULE_SUCCESS:
      return {
        ...state,
        rule: action.payload,
        loadingTests: false,
      }

    case UPDATE_CUSTOM_RULE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_RULE_RESULT_TIME:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }
    case GET_RULE_RESULT_TIME_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
      }
    case GET_RULE_RESULT_TIME_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }
    case GET_RESULT_TIME:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }
    case GET_RESULT_TIME_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
        paging: { dataSize: action.payload.length },
      }

    case GET_RESULT_TIME_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }
    case UPDATE_RESULT_TIME:
      return {
        ...state,
      }
    case UPDATE_RESULT_TIME_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_RESULT_TIME_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case EXECUTE_CUSTOM_RULE:
      return {
        ...state,
        loadingExecuteCustomRule: true,
        runRuleTest: {}
      }
    case EXECUTE_CUSTOM_RULE_SUCCESS:
      return {
        ...state,
        runRuleTest: action.payload,
        loadingExecuteCustomRule: false,
      }

    case EXECUTE_CUSTOM_RULE_FAIL:
      return {
        ...state,
        loadingExecuteCustomRule: false,
        error: action.payload,
      }
    case GET_ADDITIONAL_INFO:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }
    case GET_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        tests: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
        paging: { dataSize: action.payload.length },
      }

    case GET_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }
    case UPDATE_ADDITIONAL_INFO:
      return {
        ...state,
      }
    case UPDATE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_ADDITIONAL_INFO_FAIL:
    case GET_CUSTOM_WORKFLOW_DETAIL:
      return {
        ...state,
        loadingTests: true,
      }
    case GET_CUSTOM_WORKFLOW_DETAIL_SUCCESS:
      return {
        ...state,
        workflow: action.payload,
        loadingTests: false,
      }

    case GET_CUSTOM_WORKFLOW_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CUSTOM_RULE:
      return {
        ...state,
        loadingTests: true,
      }
    case UPDATE_CUSTOM_RULE_SUCCESS:
      return {
        ...state,
        rule: action.payload,
        loadingTests: false,
      }

    case UPDATE_CUSTOM_RULE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case IMPORT_RULE_MANAGEMENT:
      return {
        ...state,
      }
    case IMPORT_RULE_MANAGEMENT_SUCCESS:
      return {
        ...state,
      }
    case IMPORT_RULE_MANAGEMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_NORMAL_RULE_BY_TESTCODE:
      return {
        ...state,
        error: {},
        loadingTests: true,
      }

    case GET_NORMAL_RULE_BY_TESTCODE_SUCCESS:
      return {
        ...state,
        ruleTest: action.payload,
        loadingTests: false,
        updatedTime: new Date(),
      }

    case GET_NORMAL_RULE_BY_TESTCODE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingTests: false,
      }
    case UPDATE_NORMAL_RANGE_BY_TESTCODE:
      return {
        ...state,
      }

    case UPDATE_NORMAL_RANGE_BY_TESTCODE_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_NORMAL_RANGE_BY_TESTCODE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_POSITION_SCROLL:
      return {
        ...state,
        position: action.payload,
      }
    case UPDATE_NORMAL_RANGE_SUB:
      return {
        ...state,
      }

    case UPDATE_NORMAL_RANGE_SUB_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_NORMAL_RANGE_SUB_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_NORMAL_RANGE_SUB:
      return {
        ...state,
      }

    case GET_NORMAL_RANGE_SUB_SUCCESS:
      return {
        ...state,
        normalRangeSub: action.payload
      }

    case GET_NORMAL_RANGE_SUB_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
export default RuleManagement
